import {
  GET_SKU_DATA,
  RESET_REDUX_STATE,
  GET_MASTER_UOM_DATA,
  GET_ALL_SKU_DATA,
  SKU_INVENTORY_BY_SKU_ID,
  CLEAR_SKU_INVENTORY_BY_SKU_ID
} from "../constants";

const initialValues = {
  sku_data_list: "",
  master_uom: [],
  allSkuData: [],
  inventorySKUAvailable: []
};

const skuMaster = (state = initialValues, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SKU_DATA: {
      return {
        ...state,
        sku_data_list: payload,
      };
    }

    case RESET_REDUX_STATE: {
      return initialValues;
    }

    case GET_MASTER_UOM_DATA: {
      return {
        ...state,
        master_uom: payload,
      };
    }

    case GET_ALL_SKU_DATA: {
      return {
        ...state,
        allSkuData: payload,
      };
    }

    case SKU_INVENTORY_BY_SKU_ID: {
      return {
        ...state,
        inventorySKUAvailable: [...state.inventorySKUAvailable, payload]
      }
    }

    default: {
      return state;
    }
  }
};

export default skuMaster;
